import { Component, type ErrorInfo, type ReactNode } from "react";

export class AppErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Application render failed", error, info.componentStack);
  }

  render() {
    if (this.state.failed)
      return (
        <main
          role="alert"
          className="min-h-screen flex flex-col items-center justify-center gap-4 p-6"
        >
          <h1 className="text-lg font-semibold">Impossible d’afficher cette page.</h1>
          <p>Rechargez la page pour réessayer.</p>
          <button className="underline" onClick={() => window.location.reload()}>
            Recharger la page
          </button>
          <a className="underline" href="/">
            Retour à l’accueil
          </a>
        </main>
      );
    return this.props.children;
  }
}
